import styled from 'styled-components';

import { BasicParagraph } from '../../foundations/typefaces/BasicParagraph';
import style from '../../style';
import { Size } from './types';

interface IconProps {
  $disabled?: boolean;
}

export const Icon = styled.i<IconProps>(
  ({ theme: { color, transition }, $disabled }) => ({
    color: $disabled
      ? color.content.secondary.disabled()
      : color.content.secondary.default(),
    transition: transition.standard('color'),
  }),
);

export const Button = styled.button(({ theme: { color, transition }, disabled }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: transition.standard('background-color'),
  cursor: disabled ? 'not-allowed' : 'pointer',

  ...style.mixins.devices.desktop({
    ...(!disabled && {
      ':hover': {
        backgroundColor: color.background.primary.hover(),

        [Icon]: {
          color: color.content.secondary.hover(),
        },
      },
    }),
  }),
}));

export const Input = styled(BasicParagraph)(({ theme: { color, size, transition } }) => ({
  border: 'none',
  outline: 'none',
  textAlign: 'center',
  color: color.content.secondary.default(),
  padding: 0,
  transition: transition.standard('color'),
  width: size.units(4),

  ':focus, :hover': {
    color: color.content.secondary.hover(),
  },

  '::-webkit-inner-spin-button': {
    margin: 0,
    '-webkit-appearance': 'none',
  },

  '&[type=number]': {
    '-moz-appearance': 'textfield',
  },
}));

interface WrapperProps {
  $size: Size;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { color, size, shadow }, $size }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    height: $size === Size.BIG ? size.units(5) : size.units(3),
    boxShadow: shadow.short,
    borderRadius: $size === Size.BIG ? size.units(1) : size.units(0.5),
    padding: `0 ${size.units(0.5)}`,
    backgroundColor: color.background.primary.default(),

    [Button]: {
      height: $size === Size.BIG ? size.units(4) : size.units(2),
      width: $size === Size.BIG ? size.units(4) : size.units(2),
      borderRadius: $size === Size.BIG ? size.units(0.5) : size.units(0.25),
    },
  }),
);
